import { render, staticRenderFns } from "./TableBox.vue?vue&type=template&id=7411380c&scoped=true"
var script = {}
import style0 from "./TableBox.vue?vue&type=style&index=0&id=7411380c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7411380c",
  null
  
)

export default component.exports